import { HTTPAPI } from "./base";
import * as qs from 'qs';


const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";    
    return token;
}

function composePath(path, urlParams=null, routeParams=null) {
    if(routeParams) {
        for(let key of Object.keys(routeParams)) {
            path = path.replace(key, routeParams[key]);
        }
    }    
    let finalPath = "/" + path;
    if(urlParams) {
        if(typeof urlParams === 'string') {
            finalPath += "?" + encodeURIComponent(urlParams);
        }
        else {
            finalPath += "?" + encodeURIComponent(qs.stringify(urlParams));
        }        
    }     
    return finalPath;
}

export const srvApi = {
    get: (path, urlParams=null, routeParams=null) => {                
        return HTTPAPI(grabToken())
        .get(composePath(path, urlParams, routeParams));
    },
    post: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .post(composePath(path, urlParams, routeParams), data);
    },
    put: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .put(composePath(path, urlParams, routeParams), data);
    },
    patch: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .patch(composePath(path, urlParams, routeParams), data);
    },
    delete: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .delete(composePath(path, urlParams, routeParams));
    },
    postfile: (path, data, onUploadProgress=null, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .post(
            composePath(path, urlParams, routeParams), 
            data,
            {
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                onUploadProgress
            }
        );
    },
    downloadfile: (path, filename, urlParams=null, routeParams=null) => {
        return HTTPAPI(grabToken())
        .get(
            composePath(path, urlParams, routeParams),            
            {
                headers: {
                  "Content-Type": "multipart/form-data"
                },                
                responseType: 'blob'
            }
        ).then((response) => {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        });
    }
}

export const srvApiNoAuth = {
    get: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .get(composePath(path, urlParams, routeParams));
    },
    post: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .post(composePath(path, urlParams, routeParams), data);
    },
    put: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .put(composePath(path, urlParams, routeParams), data);
    },
    patch: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .patch(composePath(path, urlParams, routeParams), data);
    },
    delete: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .delete(composePath(path, urlParams, routeParams));
    },
    postfile: (path, data, onUploadProgress=null, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .post(
            composePath(path, urlParams, routeParams), 
            data,
            {
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                onUploadProgress
            }
        );
    },
}

export const PATH = {
    // ASSIGNMENT_BATCH: "assignment/batch",
    // ASSIGNMENT_MANUALASSIGNTECH: "assignment/manualassigntech",
    // ASSIGNMENT_RESETBATCH: "assignment/resetbatch",
    // ASSIGNMENT_SETTIME: "assignment/settime",
    // ASSIGNMENT_SETPOSITION: "assignment/setposition",
    // ASSIGNMENT_AUTOCALC: "assignment/autocalc",
    // ASSIGNMENT_PREVIEWRESULT: "assignment/previewresult",
    // ASSIGNMENT_REMOVE: "assignment/remove",
    // ASSIGNMENT_EXCLUDETECHNICIAN: "assignment/excludetechnician",
    // ASSIGNMENT_INCLUDETECHNICIAN: "assignment/includetechnician",
    // ASSIGNMENT_APPOINTMENT: "assignment/appointment",
    // PROFILE_MY: "profile/my",
    // PROFILE_MYTHERAPIST: "profile/mytherapist",
    // UPLOADS_UPLOAD: "uploads/uploadasset",
    // UPLOADS_UPLOADPROFILEPIC: "uploads/uploadprofilepic",
    // BOOKING_THERAPISTS: "booking/therapists",
    // BOOKING_THERAPIST: "booking/therapist",
    USERS_ASOPTIONS: "users/asoptions",
    NETWORK_ASOPTIONS: "network/asoptions",
    NETWORK_ADDTARGETINGORG: "network/addtargetingorg",
    NETWORK_REMOVETARGETINGORG: "network/removetargetingorg",
    NETWORKOWNER_ASOPTIONS: "networkowner/asoptions",
    BRAND_ADDASSOCIATEDUSER: "brand/addassociateduser",
    BRAND_REMOVEASSOCIATEDUSER: "brand/removeassociateduser",
    BRANDREP_ADDASSOCIATEDUSER: "brandrep/addassociateduser",
    BRANDREP_REMOVEASSOCIATEDUSER: "brandrep/removeassociateduser",
    NETWORKOWNER_ADDASSOCIATEDUSER: "networkowner/addassociateduser",
    NETWORKOWNER_REMOVEASSOCIATEDUSER: "networkowner/removeassociateduser",
    CAMPAIGN_ASOPTIONS: "campaign/asoptions",

    REPORTING_CAMPAIGN_LOCATIONFILTERLIST: "campaign/reportlocationfilterlist",

    REPORTING_NETWORK: "reporting/network",
    REPORTING_UTILIZATION: "reporting/utilization",
    REPORTING_OFFLINECALENDAR: "reporting/offlinecalendar",
    REPORTING_MAIN_DASHBOARD: "reporting/main-dashboard",
    REPORTING_ACCOUNTING_FINANCIAL_OVERVIEW: "reporting/accounting/financial-overview",
    REPORTING_ACCOUNTING_PER_CAMPAIGN: "reporting/accounting/per-campaign",

    CAMPAIGN_DOWNLOADREPORT: "campaign/downloadreport",
    CAMPAIGN_DOWNLOADPROPOSAL: "campaign/downloadproposal",

    CLUSTER_DOWNLOADPRICELIST: "cluster/downloadpricelist",
    CLUSTER_ADDCOSTTYPE: "cluster/addcosttype",
    CLUSTER_REMOVECOSTTYPE: "cluster/removecosttype",
}

export const getAssetUrl = function(fileid, thumbnailOrParams) {
    //https://adminpanel.massageapp.gr/assets/c38adf71-f8b7-4a17-b377-36abcc634fc7
    //api/assets/
    let url = "/api/assets/" + fileid; // + "/" + fileid + ".png";
    if(thumbnailOrParams) {
        if(thumbnailOrParams.toString() == "true") {
            url += "";
        }
        else {
            url += thumbnailOrParams
        }
    }    
    return url; 
};